module.exports = __webpack_public_path__ + "static/NunitoSansExtraBold-aaa8142d84a797a458397f8154ee75f4.woff2";